// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1dG5s","left":"styles_left__ddckp"};